import { Power, Snowflake, AlertOctagon, BatteryCharging, HardDrive, Wifi, MessageCircle } from "lucide-react";
import { Reveal, SectionHeading, waLink } from "./shared";

const PROBLEMS = [
  { icon: Power, title: "Device Not Powering On", fix: "DC jack · shorted capacitor · PSU" },
  { icon: Snowflake, title: "Slow or Freezing Computer", fix: "Thermal throttle · bad sectors · RAM" },
  { icon: AlertOctagon, title: "Windows / macOS Errors", fix: "Corrupted bootloader · drive failure" },
  { icon: BatteryCharging, title: "Charging or Battery Issues", fix: "Safe swollen-battery replacement" },
  { icon: HardDrive, title: "Storage & Memory Upgrades", fix: "SSD upgrade + full data clone" },
  { icon: Wifi, title: "Printer, Network or Setup Help", fix: "Driver fixes · router mesh setup" },
];

export const Problems = () => (
  <section id="problems" data-testid="problems-section" className="relative py-24 sm:py-32 bg-navy/40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="Common Problems"
        title="Start with the symptom."
        accent="We'll work from there."
        sub="Six faults we revive every week at the Kembangan lab. One tap sends your exact issue to AFZ on WhatsApp."
        align="center"
      />
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.06}>
            <div
              data-testid={`problem-card-${i + 1}`}
              className="group h-full bg-card/80 border border-slate-800 rounded-2xl p-6 hover:border-brand-lime/50 transition-all duration-300 hover:shadow-[0_0_35px_rgba(170,255,0,0.12)] hover:-translate-y-1 flex flex-col"
            >
              <div className="w-12 h-12 rounded-full border-2 border-brand-lime/60 bg-brand-lime/10 flex items-center justify-center text-brand-lime shadow-[0_0_18px_rgba(170,255,0,0.25)] group-hover:scale-110 transition-transform duration-300">
                <p.icon className="w-5 h-5" />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold uppercase text-white">{p.title}</h3>
              <p className="mt-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-brand-cyan">{p.fix}</p>
              <a
                data-testid={`problem-diagnose-${i + 1}`}
                href={waLink(`Hi AFZ Tech Solution, my issue: ${p.title}. Please advise the next step.`)}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-5 inline-flex items-center gap-2 text-sm font-display font-bold uppercase tracking-wide text-brand-lime hover:text-white transition-colors duration-300 mt-auto pt-4"
              >
                <MessageCircle className="w-4 h-4" /> Diagnose this issue
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
